<template>
  <span>
    <v-btn color="success"
           small
           outline
           @click="clone"
           >
           {{ $t('replicate') }}
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'ShipmentCancelBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async clone () {
      try {
        await this.shipment.clone()
      } catch (err) {
        // empty
      }
      this.$emit('fetch')
    },
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
